import { Box, SxProps, Theme } from "@mui/material";

import { StringHelper } from "@/common/helpers/string";
import { enumService } from "@/common/services/enum";
import { RepairSpecDetalizationDto } from "@/core/api/generated/v1";

export function getDetalizationInlineText(data: RepairSpecDetalizationDto) {
  return StringHelper.join(
    [
      enumService.getEnumValueName("RepairSpecDetalizationType", data?.type),
      data?.vehicleSize && `${enumService.getEnumValueName("VehicleSize", data?.vehicleSize)} size`,
      enumService.getEnumValueName("VehicleBodyType", data?.bodyType),
      enumService.getEnumValueName("VehicleFuelType", data?.fuelType),
      data?.make?.name,
      data?.model?.name,
      data?.generation?.name,
      data?.modification?.name,
    ],
    ", ",
    {
      skipEmpty: true,
    },
  );
}

interface Props {
  detalization: RepairSpecDetalizationDto;
  sx?: SxProps<Theme>;
}

export default function RepairSpecDetalizationInline({ detalization, sx }: Props) {
  return (
    <Box component='span' sx={sx}>
      {getDetalizationInlineText(detalization)}
    </Box>
  );
}
